import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing } from "lucide-react";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, MTabs } from "@/components/mobile/parts";
import { ApprovalsTab } from "@/components/mobile/release/ApprovalsTab";
import { StuckTab } from "@/components/mobile/release/StuckTab";
import { MenuOrdersTab } from "@/components/mobile/release/MenuOrdersTab";
import { useAuth } from "@/context/AuthContext";
import { useMobile } from "@/context/MobileContext";
import { isManagerRole } from "@/lib/api";
import { canMenuOrders } from "@/lib/mobile";
import { currentSub } from "@/lib/push";

function PushHint({ manager }) {
  const [show, setShow] = useState(false);
  useEffect(() => { currentSub().then((s) => setShow(!s)).catch(() => setShow(true)); }, []);
  if (!show) return null;
  return (
    <Link to="/m/config" className="flex items-center gap-2 rounded-xl bg-[#e3f2fd] px-3 py-2.5 text-sm font-medium text-[#0d47a1]" data-testid="m-push-hint">
      <BellRing className="h-4 w-4 shrink-0" />{manager ? "Ative os avisos para o celular tocar e vibrar a cada pedido, mesmo fechado." : "Ative os avisos para saber na hora quando o gerente responder, mesmo com o app fechado."}<span className="ml-auto font-semibold underline">Ativar</span>
    </Link>
  );
}

export default function MRelease() {
  const { session } = useAuth();
  const { pendingApprovals } = useMobile();
  const manager = isManagerRole(session.user);
  const tabs = [["approvals", manager ? "Solicitações" : "Minhas solicitações", manager ? pendingApprovals : 0]];
  if (manager) tabs.push(["stuck", "Comandas presas"]);
  if (canMenuOrders(session.user)) tabs.push(["menu", "Cardápio"]);
  const [tab, setTab] = useState("approvals");
  return (
    <>
      <MTopBar title="Liberação" />
      <MPage>
        <PushHint manager={manager} />
        {tabs.length > 1 && <MTabs value={tab} onChange={setTab} items={tabs} testId="m-release-tabs" />}
        {tab === "approvals" && <ApprovalsTab manager={manager} />}
        {tab === "stuck" && <StuckTab />}
        {tab === "menu" && <MenuOrdersTab />}
      </MPage>
    </>
  );
}
